import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M.558.558a.625.625 0 0 1 .884 0L6 5.116 10.558.558a.625.625 0 1 1 .884.884L6.884 6l4.558 4.558a.625.625 0 1 1-.884.884L6 6.884l-4.558 4.558a.625.625 0 1 1-.884-.884L5.116 6 .558 1.442a.625.625 0 0 1 0-.884",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }